import { updateInitialParameters } from '../actions/internalActions';
import { getGroupMailboxInfo } from 'owa-group-common';
import { updateItemsViewCache } from '../store/cache';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store';
import { logUsage } from 'owa-analytics';
import { getGroupMailboxExternalId } from 'owa-groups-shared-store';

export function onFilesViewNavigation(scenarioName: string) {
    const groupMailboxInfo = getGroupMailboxInfo(getCurrentGroupSmtpAddress());
    logUsage(
        'FilesViewInitialVisit',
        {
            scenario: scenarioName,
            groupExternalId: getGroupMailboxExternalId(
                groupMailboxInfo && groupMailboxInfo.primarySmtpAddress
            ),
        },
        { isCore: true }
    );
    updateInitialParameters(groupMailboxInfo, scenarioName);
    updateItemsViewCache();
}
